<template>
  <div>
    <Purchase />
  </div>
</template>

<script>
// 获取接口地址
import Purchase from '@/components/gmrk/purchase'

export default {
  name: 'Gmrk',
  components: {
    // sideMenu,
    // Header,
    Purchase
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
